import Utils from '../utils';
import FindAccountModel from '../models/model.findAccount';
import FirstTimeSignInView from '../views/view.firstTimeSignIn';
import EnrollRouter from './router.enroll';

export default EnrollRouter.extend({
  initialize() {
    Utils.extendBackboneValidation();
  },

  routes() {
    return _.defaults({
      '': 'firstTimeSignin'
    }, EnrollRouter.prototype.routes);
  },

  firstTimeSignin() {
    Utils.emptyApp();
    this.view = new FirstTimeSignInView({
      model: new FindAccountModel()
    });
  }
});
